<span>Kopiraj<br>od</span>
<select (change)="handleChange($event)">
  <option>Izberite iz katere velikosti želite kopirati</option>
  <option *ngFor="let size of sizes">{{ size | mealSize }}</option>
</select>
